import { render, staticRenderFns } from "./StockStageDays.vue?vue&type=template&id=0238a37a&"
import script from "./StockStageDays.vue?vue&type=script&lang=js&"
export * from "./StockStageDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports